module.exports = __webpack_public_path__ + "images/dishonored-2_rgba(0,0,0,0.7).jpg?v=3faabf099bc1c50b2a8d7a99858ee0d4";